import PropTypes from 'prop-types';
import { ArrowLeft, Share2, Heart } from 'lucide-react';
import styles from './HeaderNav.module.css';

/**
 * HeaderNav - Fixed navigation bar for venue detail page
 * Contains back, share, and favorite buttons
 */
export function HeaderNav({ onBack, onShare, onToggleSave, isSaved }) {
  return (
    <header className={styles.header}>
      <div className={styles.backdrop} />
      
      <nav className={styles.nav}>
        <button 
          onClick={onBack}
          className={styles.button}
          aria-label="Go back"
        >
          <ArrowLeft size={24} />
        </button>
        
        <div className={styles.actions}>
          <button 
            onClick={onShare}
            className={styles.button}
            aria-label="Share venue"
          >
            <Share2 size={20} />
          </button>
          
          <button 
            onClick={onToggleSave}
            className={`${styles.button} ${styles.favoriteButton} ${isSaved ? styles.saved : ''}`}
            aria-label={isSaved ? 'Remove from favorites' : 'Add to favorites'}
          >
            <Heart 
              size={20} 
              className={styles.heartIcon}
              fill={isSaved ? 'currentColor' : 'none'}
            />
          </button>
        </div>
      </nav>
    </header>
  );
}

HeaderNav.propTypes = {
  onBack: PropTypes.func.isRequired,
  onShare: PropTypes.func.isRequired,
  onToggleSave: PropTypes.func.isRequired,
  isSaved: PropTypes.bool.isRequired,
};

export default HeaderNav;
